window.addEventListener("load", function(){

initCollectionSizes()

// let currentPage = location.href;

// const checkPageLocation = function() {
// collectionSizesPageChange()
// }

// let collectionWrapper = document.querySelector('.products.boost-pfs-filter-products')

// let observer = new MutationObserver(checkPageLocation);

// observer.observe(collectionWrapper, {
// childList: true // observe direct children
// });

});

function initCollectionSizes() {
    document.querySelectorAll('.sizes-wrapper').forEach( (el) => {
    collectionSizesSetGrid(el)
    })

    document.querySelectorAll('.sizes-list-item').forEach( (el) => {
    collectionSizesSetEvent(el)
    })
    setTimeout(() => {
        window._swat.initializeActionButtons('#product-grid')
    }, 100);

    const openButtons = document.querySelectorAll('.add-to-bag-modal-open');
    const closeButtons = document.querySelectorAll('.add-to-bag-modal-close');

    openButtons.forEach(openButton => {
        openButton.addEventListener('click', event => {
            const modal = event.target.nextElementSibling;
            modal.classList.add('modal-open');
            const dropdown = event.target.closest('.product__info').querySelector('.dropdownbox-selected-variant');
            dropdown.textContent = 'Please Select';
            const notifyMe = modal.querySelector('.notify-me-a');
            notifyMe.style.display = 'none';
            const addButton = modal.querySelector('.collection_add');
            addButton.value = 'Add To Bag';
            addButton.style.display = 'block';
        });
    });
    closeButtons.forEach(closeButton => {
        closeButton.addEventListener('click', event => {
            const modal = event.target.closest('.add-to-bag-modal');
            modal.classList.remove('modal-open');
            const dropdowns = document.querySelectorAll('.main-list-variants');
            dropdowns.forEach(dropdown => {
                dropdown.classList.remove('showMenu');
            });
        });
    });
}

// function collectionSizesPageChange() {
// console.log('test')
// let url = `${window.location.href}`;
// let dataPage = 1;
// if(url.indexOf("page=") > -1 ) {
// let currentPage = url.split("page=")[1].split("&")[0]
// let pageNumber = parseInt(currentPage)
//     dataPage = pageNumber;
// }
// setTimeout(() => {
// let collectionSizesWrapper = document.querySelectorAll(`div[data-page="${Number(dataPage)}"] .sizes-wrapper`)
// collectionSizesWrapper.forEach(el => {
//     if (el.getAttribute('grid-size-set') !== 'true') {
//     collectionSizesSetGrid(el)
//     }
// })

// let collectionPageItemSizeEls = document.querySelectorAll(`div[data-page="${Number(dataPage)}"] .sizes-list-item`)
// collectionPageItemSizeEls.forEach(el => {

//     if (el.getAttribute('listener') !== 'true') {
//     collectionSizesSetEvent(el)
//     }
// });
// }, 900);
// }

function collectionSizesSetGrid (el) {
if (el.childElementCount > 8) {
    el.classList.add('collection-sizes-grid-5')
} else if (el.childElementCount > 4) {
    el.classList.add('collection-sizes-grid-4')
} else {
    el.classList.add('collection-sizes-grid-2')
}
el.setAttribute('grid-size-set', 'true')
}

function collectionSizesSetEvent(el) {
// When a size is clicked toggle the active class and update the variant id that gets submittes when being added to cart
el.addEventListener("click", function(event){
    // add active class to target
    event.target.classList.toggle("active-size-item")
    // Loop through and remove class from targets siblings
    let sibling  = event.target.parentNode.firstChild;
    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== event.target) {
            sibling.classList.remove('active-size-item')
        }
        sibling = sibling.nextSibling;
    }
    // Update the product form input with the variant id of the selected size
    let listWrapper = event.target.parentNode
    let formVariantInput = listWrapper.parentNode.querySelector('form input[name="id"]')
    let formSubmitButton = listWrapper.parentNode.querySelector('.collection-page-add-to-cart')
    let notifyMeButton = listWrapper.parentNode.querySelector('.collection-notify-btn')
    formSubmitButton.classList.remove('notify')
    formSubmitButton.disabled = false
    formVariantInput.setAttribute('value', event.target.getAttribute('data-variant-id'))
    if (event.target.getAttribute('data-variant-available') === "false") {
    formSubmitButton.classList.add('hidden')
    notifyMeButton.classList.remove('hidden')
    notifyMeButton.setAttribute('href', event.target.getAttribute('data-variant-url'))
    } else {
    formSubmitButton.setAttribute('value', 'Add To Bag')
    formSubmitButton.classList.remove('hidden')
    notifyMeButton.classList.add('hidden')
    }
});
el.setAttribute('listener', 'true');
}